var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"vcvYkl37-T9DuVH6J6Sxf"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { isProductionOrStaging } from './util/env';

import packageJson from './package.json';

const { version } = packageJson;

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
  release: version,
  dsn:
    SENTRY_DSN ||
    'https://bb1334f526db44fd9a6488e6ea2c04cb@o163991.ingest.sentry.io/1453407',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.1,
  enabled: isProductionOrStaging,
  ignoreErrors: [
    // Happens when ad blockers block Bing trackers
    'ReferenceError: UET is not defined',

    // Not related to our codebase
    "ReferenceError: Can't find variable: zaloJSV2",
    "Can't find variable: gmo",
    'Chartboost is not defined',
    "Can't find variable: Chartboost",
    "Cannot read properties of null (reading 'type')",
    'this.shouldEnforce is not a function',
  ],
});
